module.exports = __webpack_public_path__ + "static/img/lucky_draw_banner_en@2x.cbc2837.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/greenchannel/lucky_draw_banner_en@2x.png
// module id = ck9G
// module chunks = 1